import { useContext } from 'react';
import { AuthContext } from '../hoc/AuthProvider';

export function useAuth() {
	const context = useContext(AuthContext);
	if (context === null) {
		throw new Error('useAuth must be used within a AuthProvider');
	}
	return context;
}
